import { useLocation } from '@reach/router';

export default function useLocationHash(): string {
    return useLocation().hash;
}
